<template>
    <div class="joblist">
        <div class="main-wrapper">
            <layout-headerApp></layout-headerApp>

            <body>
                <!-- Page Wrapper -->
                <div class="page-wrapper job-wrapper" style="font-family: 'CircularStd', sans-serif;
        font-size: .9375rem;
        color: #1f1f1f;
        background-color: #f7f7f7;
        min-height: 100%;
        overflow-x: hidden;">

                    <!-- Page Content -->
                    <div class="content container">

                        <!-- Page Header -->
                        <div class="page-header">
                            <div class="row">
                                <div class="col-sm-12">
                                    <h3 class="page-title">Jobs</h3>
                                    <ul class="breadcrumb">
                                        <li class="breadcrumb-item">
                                            <router-link to="/index">Dashboard</router-link>
                                        </li>
                                        <li class="breadcrumb-item active">Jobs</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!-- /Page Header -->

                        <div class="row">
                            <div class="col-md-6">
                                <router-link to="/jobview" class="job-list">
                                    <div class="job-list-det">
                                        <div class="job-list-desc">
                                            <h3 class="job-list-title">Web Devloper</h3>
                                            <h4 class="job-department">Development</h4>
                                        </div>
                                        <div class="job-type-info">
                                            <span class="job-types">Full Time</span>
                                        </div>
                                    </div>
                                    <div class="job-list-footer">
                                        <ul>
                                            <li><i class="fa fa-map-signs"></i> California</li>
                                            <li><i class="fa fa-money"></i> $35000-$38000</li>
                                            <li><i class="fa fa-clock-o"></i> 2 days ago</li>
                                        </ul>
                                    </div>
                                </router-link>
                            </div>
                            <div class="col-md-6">
                                <router-link to="/jobview" class="job-list">
                                    <div class="job-list-det">
                                        <div class="job-list-desc">
                                            <h3 class="job-list-title">Android Devloper</h3>
                                            <h4 class="job-department">App Development</h4>
                                        </div>
                                        <div class="job-type-info">
                                            <span class="job-types">Part Time</span>
                                        </div>
                                    </div>
                                    <div class="job-list-footer">
                                        <ul>
                                            <li><i class="fa fa-map-signs"></i> California</li>
                                            <li><i class="fa fa-money"></i> $35000-$38000</li>
                                            <li><i class="fa fa-clock-o"></i> 2 days ago</li>
                                        </ul>
                                    </div>
                                </router-link>
                            </div>
                            <div class="col-md-6">
                                <router-link to="/jobview" class="job-list">
                                    <div class="job-list-det">
                                        <div class="job-list-desc">
                                            <h3 class="job-list-title">Web Devloper</h3>
                                            <h4 class="job-department">Development</h4>
                                        </div>
                                        <div class="job-type-info">
                                            <span class="job-types">Full Time</span>
                                        </div>
                                    </div>
                                    <div class="job-list-footer">
                                        <ul>
                                            <li><i class="fa fa-map-signs"></i> California</li>
                                            <li><i class="fa fa-money"></i> $35000-$38000</li>
                                            <li><i class="fa fa-clock-o"></i> 2 days ago</li>
                                        </ul>
                                    </div>
                                </router-link>
                            </div>
                            <div class="col-md-6">
                                <router-link to="/jobview" class="job-list">
                                    <div class="job-list-det">
                                        <div class="job-list-desc">
                                            <h3 class="job-list-title">Android Devloper</h3>
                                            <h4 class="job-department">App Development</h4>
                                        </div>
                                        <div class="job-type-info">
                                            <span class="job-types">Part Time</span>
                                        </div>
                                    </div>
                                    <div class="job-list-footer">
                                        <ul>
                                            <li><i class="fa fa-map-signs"></i> California</li>
                                            <li><i class="fa fa-money"></i> $35000-$38000</li>
                                            <li><i class="fa fa-clock-o"></i> 2 days ago</li>
                                        </ul>
                                    </div>
                                </router-link>
                            </div>
                            <div class="col-md-6">
                                <router-link to="/jobview" class="job-list">
                                    <div class="job-list-det">
                                        <div class="job-list-desc">
                                            <h3 class="job-list-title">Web Devloper</h3>
                                            <h4 class="job-department">Development</h4>
                                        </div>
                                        <div class="job-type-info">
                                            <span class="job-types">Full Time</span>
                                        </div>
                                    </div>
                                    <div class="job-list-footer">
                                        <ul>
                                            <li><i class="fa fa-map-signs"></i> California</li>
                                            <li><i class="fa fa-money"></i> $35000-$38000</li>
                                            <li><i class="fa fa-clock-o"></i> 2 days ago</li>
                                        </ul>
                                    </div>
                                </router-link>
                            </div>
                            <div class="col-md-6">
                                <router-link to="/jobview" class="job-list">
                                    <div class="job-list-det">
                                        <div class="job-list-desc">
                                            <h3 class="job-list-title">Android Devloper</h3>
                                            <h4 class="job-department">App Development</h4>
                                        </div>
                                        <div class="job-type-info">
                                            <span class="job-types">Part Time</span>
                                        </div>
                                    </div>
                                    <div class="job-list-footer">
                                        <ul>
                                            <li><i class="fa fa-map-signs"></i> California</li>
                                            <li><i class="fa fa-money"></i> $35000-$38000</li>
                                            <li><i class="fa fa-clock-o"></i> 2 days ago</li>
                                        </ul>
                                    </div>
                                </router-link>
                            </div>
                            <div class="col-md-6">
                                <router-link to="/jobview" class="job-list">
                                    <div class="job-list-det">
                                        <div class="job-list-desc">
                                            <h3 class="job-list-title">Web Devloper</h3>
                                            <h4 class="job-department">Development</h4>
                                        </div>
                                        <div class="job-type-info">
                                            <span class="job-types">Full Time</span>
                                        </div>
                                    </div>
                                    <div class="job-list-footer">
                                        <ul>
                                            <li><i class="fa fa-map-signs"></i> California</li>
                                            <li><i class="fa fa-money"></i> $35000-$38000</li>
                                            <li><i class="fa fa-clock-o"></i> 2 days ago</li>
                                        </ul>
                                    </div>
                                </router-link>
                            </div>
                            <div class="col-md-6">
                                <router-link to="/jobview" class="job-list">
                                    <div class="job-list-det">
                                        <div class="job-list-desc">
                                            <h3 class="job-list-title">Android Devloper</h3>
                                            <h4 class="job-department">App Development</h4>
                                        </div>
                                        <div class="job-type-info">
                                            <span class="job-types">Part Time</span>
                                        </div>
                                    </div>
                                    <div class="job-list-footer">
                                        <ul>
                                            <li><i class="fa fa-map-signs"></i> California</li>
                                            <li><i class="fa fa-money"></i> $35000-$38000</li>
                                            <li><i class="fa fa-clock-o"></i> 2 days ago</li>
                                        </ul>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- /Page Wrapper -->
            </body>
        </div>
    </div>
</template>

<script>
    import LayoutHeaderApp from '@/components/layouts/HeaderApp.vue'
    export default {
        components: {
            LayoutHeaderApp,
        },
        mounted() {
            // Date Time Picker

            if ($('.datetimepicker').length > 0) {
                $('.datetimepicker').datetimepicker({
                    format: 'DD/MM/YYYY',
                    icons: {
                        up: "fa fa-angle-up",
                        down: "fa fa-angle-down",
                        next: 'fa fa-angle-right',
                        previous: 'fa fa-angle-left'
                    }
                });
            }

            if ($('.floating').length > 0) {
                $('.floating').on('focus blur', function (e) {
                    $(this).parents('.form-focus').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
                }).trigger('blur');
            }
        },
        name: 'joblist'
    }
</script>


// WEBPACK FOOTER //
// src/components/joblist.vue